import { render, staticRenderFns } from "./ModalPackagingSettings.vue?vue&type=template&id=053b00d3&scoped=true&"
import script from "./ModalPackagingSettings.vue?vue&type=script&lang=js&"
export * from "./ModalPackagingSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalPackagingSettings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ModalPackagingSettings.vue?vue&type=style&index=1&id=053b00d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053b00d3",
  null
  
)

export default component.exports